import { cloneDeep, reduce } from 'lodash'
import generateUuid from 'uuid/v4'
import { getDeviceId } from './deviceData'

export const nextPosOrderNumber = (readOnly = false) => {
  const rangeMin = parseInt(localStorage.getItem('orderNumberMin')) || 1000
  const rangeMax = parseInt(localStorage.getItem('orderNumberMax')) || 1999

  let oldId = parseInt(localStorage.getItem('posOrderNumber')) || rangeMin

  // if it's out of range, let's assume the range has changed after a re-registration
  if (oldId < rangeMin || oldId > rangeMax) oldId = rangeMin

  let newId = oldId + 1
  // rollover / reset
  if (newId > rangeMax) newId = rangeMin

  if (!readOnly) {
    localStorage.setItem('posOrderNumber', newId)
  }
  return newId
}

const executeNextSplitOrderNumber = (orderNumber) => {
  const tagLength = 3
  const tagRegex = new RegExp(`(-[a-z0-9]{${tagLength}}){1,}$`, 'i')
  const baseOrderNumber = `${orderNumber}`.replace(tagRegex, '')
  const ulid = generateUuid()
  const shortenedUniqueIdentifier = ulid.substring(ulid.length - tagLength)

  return `${baseOrderNumber}-${shortenedUniqueIdentifier}`
}

const SplitOrderNumberRecord = (baseOrderNumber) => {
  const orderNumberString = `${baseOrderNumber}`

  return {
    createdAt: Date.now(),
    key: orderNumberString,
    value: executeNextSplitOrderNumber(orderNumberString),
  }
}

const SplitOrderNumberManagerFactory = () => {
  let cacheMap = new Map()

  const exists = (orderNumber) => {
    const orderNumberString = `${orderNumber}`

    return cacheMap.has(orderNumberString)
  }

  const findOrCreate = (orderNumber) => {
    const orderNumberString = `${orderNumber}`

    if (!cacheMap.has(orderNumberString)) {
      cacheMap.set(orderNumberString, SplitOrderNumberRecord(orderNumberString))
    }

    return cacheMap.get(orderNumberString).value
  }

  const destroy = (orderNumber) => {
    const orderNumberString = `${orderNumber}`
    cacheMap.delete(orderNumberString)
  }

  // Remove all records that are more than 30 minutes old
  const cleanup = () => {
    for (let [key, record] of cacheMap) {
      const HALF_HOUR_MS = 30 * 60 * 1000
      const elapsedTime = Date.now() - record.createdAt

      if (elapsedTime > HALF_HOUR_MS) {
        cacheMap.delete(key)
      }
    }
  }

  // Deep clone to prevent mutability
  const cache = () => {
    return cloneDeep(cacheMap)
  }

  return {
    cache,
    exists,
    destroy,
    cleanup,
    findOrCreate,
  }
}

export const SplitOrderNumberManager = SplitOrderNumberManagerFactory()

// Pad a number with leading zeros.
const padString = (str, length) => {
  let padded = str

  if (!str) {
    padded = ''
  }

  while (padded.length < length) {
    padded = `0${padded}`
  }

  return padded
}

// orderNumber : The order number as specified within the bounds of this device's order number
//     range.
// returns : An invoice number that can track the order number and device number within a payment
//     processor's system.

const hexKey = {
  a: '10',
  b: '11',
  c: '12',
  d: '13',
  e: '14',
  f: '15',
}

const convertToBaseTen = (deviceId) => {
  return reduce(deviceId?.toLowerCase().split(''), (convertedId, symbol) => convertedId + (hexKey[symbol] ?? symbol), '')
}

export const invoiceNumber = (orderNumber) => {
  console.log(orderNumber, getDeviceId(), convertToBaseTen(getDeviceId()))
  const deviceId = convertToBaseTen(getDeviceId())
  return padString(deviceId?.slice(-4), 4) + padString(orderNumber.slice(-6), 6)
}

export default nextPosOrderNumber
